import { Button, Card, Icon } from "antd";
import React, { Fragment } from "react";

export function RenderDistributorInfo({ distributor, shop, status_price, changeDistribotor }) {
    return (
        <Fragment>
            <div className="distributor-view">
                <Card className="card-covered distributor-view__container">
                    <h2><b>{distributor.name}</b></h2>
                    <p><a href={"mailto:"+distributor.email}> <Icon type="mail" />  {distributor.email}</a></p>
                    
                    <div className="ant-card-head-wrapper">
                        <h3 className="ant-card-head-title">Магазин: </h3>
                    </div>

                    <div className="distributor-view__shop">
                        <h3 className="card-content card-content-bold"><b>{shop.responsible_person}</b></h3>
                        
                        <p className="card-content card-content-bold">{shop.address}</p>
                        <p className="card-content card-content-bold">{shop.city}</p>
                        <div className="distributor-view__shop-links">
                            <a href={"mailto:"+shop.email_of_responsible} className="card-content card-content-bold"><Icon type="mail" /> {shop.email_of_responsible}</a>
                            <a href={"tel:"+shop.phone} className="card-content card-content-bold"><Icon type="phone" /> {shop.phone}</a>
                        </div>
                        { shop.phones.length !== 0 ? 
                            <Fragment>
                                <div className="ant-card-head-wrapper">
                                    <div className="ant-card-head-title">Другие тель. номера: </div>
                                </div>
                                <div className="distributor-view__shop-tel">
                                    {shop.phones.map((phone, i)=> <a key={i} href={"tel:"+phone.number} className="card-content card-content-bold"><Icon type="phone" /> {phone.number}</a>)}
                                </div>
                            </Fragment>
                            : null 
                        }
                    </div>
                    { status_price === 'SENT' ? 
                        <Button type="primary" 
                            className="distributor-view__btn" 
                            onClick={changeDistribotor}>Сменить дистрибьютора</Button> 
                        : null 
                    }
                </Card>
            </div>
        </Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/pages/projects/application/RenderDistributorInfo.js